import { getResponsiveSize } from './../../../Utils/Formatters/responsiveSize'
export const auxiliaries = {
    spacing: (value: number) => Number(value) ** 2,
    getResponsiveSize: getResponsiveSize,
}
